import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Role } from '@data/models/role.model';
import { AclsDetailsDialogComponent } from '../acls-details-dialog/acls-details-dialog.component';

@Component({
    selector: 'syn-select-option-role',
    templateUrl: 'select-option-role.component.html',
    styleUrls: ['select-option-role.component.scss']
})
export class SelectOptionRoleComponent {
    @Input() role: Role;

    constructor(private matDialog: MatDialog) {
    }

    public displayAclsInformation(role: Role): void {
        this.matDialog.open(AclsDetailsDialogComponent, {
            data: {
                roles: [role],
                row: { roles: [role.id] }
            },
            width: '800px'
        });
    }
}
